/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getUserWorkInfoTable = params => {
  return axios.post(`${base}/user_work_info_audit/query`, params)
}
export const getUserWorkInfoDetail = params => {
  return axios.get(`${base}/user_work_info_audit/${params.id}`, {params})
}
export const auditUserWorkInfoData = params => {
  return axios.post(`${base}/user_work_info_audit/${params.id}/audit`, params)
}
export const getNextAuditWorkInfoId = params => {
  return axios.get(`${base}/user_work_info_audit/next_audit_id`, {})
}
export const batchRejectWorkInfoApi = params => {
  return axios.post(`${base}/batch_jobs/batch_reject_user_workinfo`, params)
}
export const batchExpireWorkInfoApi = params => {
  return axios.post(`${base}/batch_jobs/batch_expire_user_workinfo`, params)
}
export const queryWorkInfoSnapshotApi = params => {
  return axios.post(`${base}/user_work_info_audit/query_snapshot`, params)
}
export const getUserLatestWorkInfoApi = params => {
  return axios.get(`${base}/user_work_info_audit/get_latest_workinfo_${params.userid}`, {params})
}
export const exportUserAuditWorkInfoApi = params => {
  return axios.post(`${base}/batch_jobs/batch_export_user_audit_workinfo`, params)
}
export const queryWorkInfoCompany = params => {
  return axios.post(`${base}/work_info_company/query`, params)
}



// WEBPACK FOOTER //
// ./src/views/user-workinfo/user-workinfo.api.js